import request from './interceptor'
import { mockRequestDelay } from '../utils/mock'

// 是否使用mock数据，开发环境下默认使用
const USE_MOCK = false;

// 模拟设备数据
const mockDevicesData = {
  code: 0,
  message: 'success',
  data: {
    devices: [
      {
        id: 4,
        device_code: 'SN2837483648940',
        install_address: '北京市朝阳区CBD商业街A座1楼大厅',
        install_time: '2023-12-31 16:00:00',
        container_recycle_price: 3,
        current_weight: 0,
        company_id: 1,
        recycle_mode: 4,
        status: 1,
        hardware_status: '11100',
        expire_time: '2025-12-30 16:00:00',
        container_name: '投递给钱开箱付费持有人获得差额',
        version: 7803,
        camera_serial_number: 'CAM20240001',
        camera_password: 'cam123456',
        holder_user_id: 1,
        created_at: '2025-06-27 09:38:29',
        updated_at: '2025-09-08 02:25:16',
        company_info: {
          id: 1,
          name: '示例科技有限公司',
          address: '北京市朝阳区示例大厦10层',
          manager_name: '张经理',
          manager_phone: '13800138000',
          customer_service_phone: '400-123-4567',
          recycle_bin_unit_price: 2.5,
          recycle_bin_status: 1,
          status_description: '',
          is_deleted: false,
          created_at: '2025-06-09 23:40:29',
          updated_at: '2025-09-08 02:21:15'
        },
        holder_user_info: {
          id: 1,
          openid: 'wx_user_20241215_789456123',
          unionid: 'union_20241215_456789012',
          phone: '13812345678',
          company_id: 0,
          balance: 0,
          register_time: '',
          last_login_time: '',
          is_deleted: false,
          created_at: '',
          updated_at: ''
        }
      }
    ],
    total: 1
  }
};

/**
 * 获取设备列表
 * @param {Object} params - 查询参数
 */
export function getDevices(params = {}) {
  if (USE_MOCK) {
    // 使用mock数据
    return new Promise((resolve) => {
      mockRequestDelay().then(() => {
        resolve(mockDevicesData);
      });
    });
  } else {
    // 实际请求后端API
    return request({
      url: '/v1/devices',
      method: 'get',
      params: params
    });
  }
}

/**
 * 获取设备详情
 * @param {Number} id - 设备ID
 */
export function getDeviceDetail(id) {
  return request({
    url: `/v1/devices/${id}`,
    method: 'get'
  });
}

/**
 * 获取设备统计（分页）
 * @param {Object} params - { page, page_size }
 */
export function getDevicesStatsPage(params = {}) {
  return request({
    url: '/v1/devices/stats',
    method: 'get',
    params
  })
}
